export default {"src":"/_next/static/media/3-Inkasso.21de4b9d.svg","height":87,"width":87,"blurWidth":0,"blurHeight":0};